import { render, staticRenderFns } from "./SimpleExamModelInfo.vue?vue&type=template&id=cb83e840&"
import script from "./SimpleExamModelInfo.vue?vue&type=script&lang=js&"
export * from "./SimpleExamModelInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports